<section class="disclosure-detail">
  @if (isLoading()) {
  <div class="state-panel" role="status" aria-live="polite">
    <app-progress-spinner [diameter]="56" />
    <h2 class="state-panel__title">Loading disclosure…</h2>
    <p class="state-panel__message">Hang tight while we fetch this access event.</p>
  </div>
  } @else if (loadError()) {
  <div class="state-panel" role="alert">
    <span
      class="state-panel__icon"
      [class.state-panel__icon--error]="!notFound()"
      aria-hidden="true"
    >
      <app-icon
        [name]="errorIcon()"
        size="custom"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
    </span>
    <h1 class="state-panel__title">{{ errorTitle() }}</h1>
    <p class="state-panel__message">{{ loadError() }}</p>
    <a class="primary-button state-panel__button fw-600" routerLink="/activity-logs">
      <app-icon
        name="chevron_left"
        size="sm"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
      <span>Back to Activity Log</span>
    </a>
  </div>
  } @else if (detail(); as detail) {
  <nav class="breadcrumb flex align-center gap-8 fs-12 mb-15" aria-label="Breadcrumb">
    <a
      class="breadcrumb__link fw-600"
      routerLink="/activity-logs"
      aria-label="Return to the activity log"
      >Activity Log</a
    >
    @if (actorName()) {
    <app-icon
      class="breadcrumb__icon"
      name="chevron_right"
      size="xs"
      color="custom"
      customColor="currentColor"
      role="presentation"
    ></app-icon>
    <span>{{ actorName() }}</span>
    }
    <app-icon
      class="breadcrumb__icon"
      name="chevron_right"
      size="xs"
      color="custom"
      customColor="currentColor"
      role="presentation"
    ></app-icon>
    <span aria-current="page">{{ featureArea() }} — {{ accessedOn() }}</span>
  </nav>

  <header class="page-header">
    <h1 class="page-title fs-22 fw-700 m-0">{{ featureArea() }}</h1>
    <p class="page-subtitle">{{ subtitle() }}</p>
  </header>

  @if (severityNote(); as severityNote) {
  <div class="severity-banner flex align-center gap-8" role="note">
    <app-icon
      class="severity-banner__icon"
      name="warning"
      size="sm"
      color="custom"
      customColor="currentColor"
      role="presentation"
    ></app-icon>
    <span>{{ severityNote }}</span>
  </div>
  }

  <section class="records-card" aria-labelledby="records-title">
    <div class="records-card__header flex justify-between align-center gap-8">
      <h2 id="records-title" class="records-card__title">Items visible during this session</h2>
      <span class="records-card__count fs-12"
        >{{ filteredRows().length }} {{ filteredRows().length === 1 ? 'item' : 'items' }}</span
      >
    </div>

    <div class="records-card__search">
      <app-input label="Search" inputId="record-search" icon="search">
        <input
          id="record-search"
          type="search"
          [ngModel]="searchTerm()"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Search by name or type…"
          aria-label="Search disclosed records by name or type"
        />
      </app-input>
    </div>

    @if (filteredRows().length === 0) {
    <div
      class="records-status flex flex-col align-center justify-center text-center"
      aria-live="polite"
    >
      <h3>{{ hasActiveSearch() ? 'No matching records' : 'No records disclosed' }}</h3>
      <p>
        {{ hasActiveSearch() ? 'Try a different name or type to broaden the results.' : 'This access
        event has no individual records to display.' }}
      </p>
    </div>
    } @else {
    <div class="records-table" role="table" aria-label="Disclosed records">
      <div
        class="records-table__header records-table__grid gap-12 fw-600 uppercase"
        [class.records-table__grid--no-description]="!showDescriptionColumn()"
        [class.records-table__grid--no-status]="!showStatusColumn()"
        role="row"
      >
        <div role="columnheader">Name</div>
        @if (showDescriptionColumn()) {
        <div role="columnheader">Description</div>
        } @if (showStatusColumn()) {
        <div role="columnheader">Status</div>
        }
        <div role="columnheader">Most Recent</div>
      </div>

      <div class="records-table__body" role="rowgroup">
        @for (row of filteredRows(); track row.id) {
        <div
          class="records-table__row records-table__grid gap-12"
          [class.records-table__grid--no-description]="!showDescriptionColumn()"
          [class.records-table__grid--no-status]="!showStatusColumn()"
          [class.records-table__row--deleted]="row.isDeleted"
          role="row"
        >
          <div class="cell cell--name" role="cell">
            <span class="cell__name">{{ row.name }}</span>
            @if (row.isDeleted) {
            <span class="status-chip status-chip--deleted">Deleted</span>
            }
          </div>

          @if (showDescriptionColumn()) {
          <div class="cell cell--description" role="cell">
            <span class="cell__secondary">{{ row.description || '—' }}</span>
          </div>
          } @if (showStatusColumn()) {
          <div class="cell cell--status" role="cell">
            @if (row.status) {
            <span class="status-chip">{{ row.status }}</span>
            } @else {
            <span class="cell__secondary">—</span>
            }
          </div>
          }

          <div class="cell cell--date" role="cell">
            <span class="cell__primary">{{ row.mostRecent }}</span>
          </div>
        </div>
        }
      </div>
    </div>
    }
  </section>
  }
</section>
